import { CognitoUserPool } from "amazon-cognito-identity-js";
import { COGNITO_USER_POOL_ID, COGNITO_CLIENT_ID } from "@/lib/env";

const poolId   = COGNITO_USER_POOL_ID;
const clientId = COGNITO_CLIENT_ID;

export const isCognitoConfigured = Boolean(poolId && clientId);

/** Local demo: skip Cognito when backend is localhost gateway (development only). */
export function isLocalDevBypassEnabled() {
  if (process.env.NODE_ENV !== "development") return false;
  if (isCognitoConfigured) return false;
  if (process.env.REACT_APP_DEV_BYPASS_AUTH === "false") return false;
  if (process.env.REACT_APP_DEV_BYPASS_AUTH === "true") return true;
  const urls = [
    process.env.REACT_APP_BACKEND_URL || "",
    process.env.REACT_APP_VIBE_CODING_STUDIO_URL || "",
  ].map((u) => u.toLowerCase());
  return urls.some((u) => u.includes("localhost") || u.includes("127.0.0.1"));
}

export const cognitoUserPool = isCognitoConfigured
  ? new CognitoUserPool({
      UserPoolId: poolId,
      ClientId: clientId,
    })
  : null;

const DEV_USER = { email: "dev@localhost", sub: "local-dev-bypass" };

export function getLocalDevUser() {
  return DEV_USER;
}
